<template>
  <div>
    <!-- <OnShelvesLog v-if="$fromGyl" /> -->
    <el-tabs type="card" v-model="activeName" class="log">
        <el-tab-pane lazy label="铺货日志(旧)" name="onShelvesLog">
          <!-- v-if="activeName == 'onShelvesLog'" -->
          <OnShelvesLog />
        </el-tab-pane>
        <el-tab-pane lazy label="铺货日志(新)" name="onShelvesLogNew">
          <OnShelvesLogNew />
        </el-tab-pane>
        <el-tab-pane lazy label="商品修改" name="prodModify">
          <ProdModify />
        </el-tab-pane>
        <el-tab-pane lazy label="商品新增" name="newProductLog">
          <!-- v-if="activeName == 'newProductLog'" -->
          <NewProductLog />
        </el-tab-pane>
        <el-tab-pane lazy label="商品删除" name="delProductLog">
          <!-- v-if="activeName == 'delProductLog'" -->
          <DelProductLog />
        </el-tab-pane>
        <el-tab-pane lazy label="更新店铺商品" name="updateToShopLog">
          <!-- v-if="activeName == 'updateToShopLog'" -->
          <UpdateToShopLog />
        </el-tab-pane>
         <el-tab-pane lazy v-if="routerPrefix == 's_'" label="小店商品操作" name="shopOperationLog">
          <!-- v-if="activeName == 'shopOperationLog'"  -->
          <ShopOperationLog />
        </el-tab-pane>
         <el-tab-pane v-if="showPutGoods && joinOcean" lazy label="货源提报" name="putGoodsLog">
          <!-- v-if="activeName == 'onShelvesLog'" -->
          <PutGoodsLog />
        </el-tab-pane>
        <el-tab-pane v-if="isStockUpload" lazy label="库存上传记录" name="recordsLog">
          <StockUploadLog />
        </el-tab-pane>
        <el-tab-pane v-if="isStockUpload" lazy label="店铺商品" name="shopGoods">
          <ShopGoods />
        </el-tab-pane>
        <el-tab-pane lazy label="推送门店商品" name="publishStoresLog">
          <OnShelvesLog :operateType="8"/>
        </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import OnShelvesLog from '@components/prod/log/onShelvesLog'
import OnShelvesLogNew from '@components/prod/log/onShelvesLogNew'
import NewProductLog from '@components/prod/log/newProductLog'
import DelProductLog from '@components/prod/log/delProductLog'
import UpdateToShopLog from '@components/prod/log/updateToShopLog'
import ShopOperationLog from '@components/prod/log/shopOperationLog'
import PutGoodsLog from '@components/prod/log/putGoodsLog';
import ProdModify from '@components/prod/log/prodModify';
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { stockUploadMixin } from '../center/utils/mixins'
import StockUploadLog from './stockUpload/index.vue';
import ShopGoods from './shopGoods/index.vue';

export default {
  components: {
    OnShelvesLog,
    OnShelvesLogNew,
    NewProductLog,
    DelProductLog,
    UpdateToShopLog,
    ShopOperationLog,
    PutGoodsLog,
    StockUploadLog,
    ProdModify,
    ShopGoods,
  },
  data() {
    return {
      showPutGoods: false,
      joinOcean: false
    }
  },
  mixins: [stockUploadMixin],
  computed: {
    ...mapGetters(['routerPrefix', 'getLogActiveName', 'getJoinOcean']),
    activeName:{
      get() {
        return this.getLogActiveName
      },
      set(newVal) {
        this.setActiveName(newVal)
      }
    }
  },
  watch:{
      getJoinOcean: {
          immediate: true,
          handler(newValue) {
             this.joinOcean = newValue;
          }
      }
  },
  methods: {
    ...mapMutations(['setActiveName']),
    ...mapActions(["queryNameList"]),
  },
  created() {
    this.queryNameList()
    let featureCodes = this.$store.getters.featureCodes;
    this.showPutGoods = featureCodes?.includes('PublicSourceReport');
    this.joinOcean = this.$store.getters.getJoinOcean;
    // 获取库存上传配置
    // this.$store.dispatch('mixture/reqConfData');
  }
}
</script>
<style>
.log .cell {
    height: 50px !important;
}
</style>